import { message, Modal, Upload } from 'hljd'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import styles from './style.module.less'

@inject('store')
@observer
class AppealModal extends Component {
  render() {
    const { store } = this.props
    const {
      auditBoxVisible,
      submitAuditHanlder,
      setAuditBoxVisible,
      setAuditMediaList
    } = store

    return (
      <Modal
        title="发起申诉"
        visible={auditBoxVisible}
        onOk={() => submitAuditHanlder(this.props.id)}
        onCancel={() => setAuditBoxVisible(false)}
        okText="发起申诉"
        width={640}
        maskClosable={false}
        keyboard={false}
      >
        <p style={{ fontWeight: 'bold' }}>
          请根据审核未通过原因上传真实可信的举证：
        </p>
        <p>1.参考价格与案例效果不符：可上传收款截图、服务合同等；</p>
        <p>
          2.案例图片涉嫌抄袭/盗图/使用网图：可上传婚礼现场原片、视频、设计手稿等；
        </p>
        <p>3.图片大小不能超过 10 MB，视频大小不能超过 500 MB。</p>
        <div className={styles.auditList}>
          <Upload
            multiple
            accept="image/*,video/*"
            upText="点击上传凭证"
            max={10}
            onChange={val => {
              setAuditMediaList(val)
            }}
            beforeUpload={(file, fileList) => {
              if (fileList.length > 10) {
                message.error({
                  content: '上传数量不得超过10个',
                  key: 'videoNum'
                })
                return false
              } else {
                if (file.type.includes('video')) {
                  if (file.size > 1024 * 1024 * 500) {
                    message.error({
                      content: '视频大小不能超过500M',
                      key: 'videoSize'
                    })
                    return false
                  } else {
                    return true
                  }
                } else {
                  if (file.size > 1024 * 1024 * 10) {
                    message.error({
                      content: '图片大小不能超过10M',
                      key: 'picSize'
                    })
                    return false
                  } else {
                    return true
                  }
                }
              }
            }}
          />
        </div>
      </Modal>
    )
  }
}

export default AppealModal
